import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  public getItem(key: string): string {
    return sessionStorage.getItem(key);
  }

  public setItem(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }

  public removeItem(key: string) {
    sessionStorage.removeItem(key);
  }

  public clearStorage()
  {
    sessionStorage.clear();
  }
}
